import React, { memo } from 'react';
import FormSteps from '../FormSteps';
import FormStepsNav from '../StepComponents/FormStepsNav';
import CompleteScreen from '../FormSteps/CompleteScreen';
import { useDispatch, useSelector } from 'react-redux';
import { endScreenSelector, formSubmitErrorSelector, stepsSelector } from '../../store/modules/steps/selectors';
import Alert from './Alert';
import { stepsActions } from '../../store/modules/steps/reducer';

const ContentArea: React.FC<any> = () => {

	const dispatch = useDispatch()
	const { formIsSubmitted } = useSelector(stepsSelector)
	const submitError = useSelector(formSubmitErrorSelector)
	const endScreen = useSelector(endScreenSelector)

	const handleHideAlert = (): void => { dispatch(stepsActions.setFormSubmitError('')) }
// removed logo because of pro-klima
	return (
		<div className={'o-heating-form-content-inner'} id={'form-top'}>
			{submitError && <Alert hideAlert={handleHideAlert}>{submitError}</Alert>}
			<div className={'inner-wrap'}>
				{formIsSubmitted
					? <div className={'completed'}>
						<CompleteScreen
							headline={endScreen.headline}
							text={endScreen.text}
							button={endScreen.button}
						/>
					</div>
					: <>
						<FormSteps />
						<FormStepsNav className={'nav-button-wrapper'} />
					</>
				}
			</div>
		</div>
	);
};

export default memo(ContentArea);
